import React, { createContext, useContext } from 'react';

import invariant from 'tiny-invariant';

import { UserMenuDataContextType, UserMenuDataProviderProps } from './types';

export const UserMenuContext = createContext<UserMenuDataContextType | null>(null);

/**
 * UserMenuDataProvider - stores the user menu-data and makes it available to child components.
 *   This component exists so that it is easy for child components to read and update the
 *   menu data independently from the UserSideNavData
 *
 * @experimental
 * Still under development. Use with caution.
 */
export function UserMenuDataProvider({ children, value }: UserMenuDataProviderProps) {
	return <UserMenuContext.Provider value={value}>{children}</UserMenuContext.Provider>;
}

export function useUserMenuData() {
	const context = useContext(UserMenuContext);

	invariant(context, 'useUserMenuData must be used inside a SidebarNav4ContextProvider');

	return context;
}
